import { Directive } from "@angular/core";

/**
 * Marker directive applied to content projected into the icon slot, replacing the default icon for the panel's variant of
 * `InfoPanelComponent`. Applies the `mgd-info-panel-icon` host class and exists so
 * `InfoPanelComponent` can detect via `@ContentChild` whether a consumer projected
 * content into this slot at all. A bare attribute cannot be queried, so the consumer must
 * import this directive wherever the slot is used.
 *
 * @example
 * ```html
 * <mgd-info-panel variant="info">
 *   <mat-icon mgdInfoPanelIcon>translate</mat-icon>
 *   Body content.
 * </mgd-info-panel>
 * ```
 *
 * @selector [mgdInfoPanelIcon]
 */
@Directive({
    selector: "[mgdInfoPanelIcon]",
    host: {
        class: "mgd-info-panel-icon"
    }
})
export class InfoPanelIconDirective {
}
